import { OptionGroupsStructure } from '@core/interfaces/option-group';

export const extractOptions = (optionGroups: OptionGroupsStructure, attributes): any => {
  let fixedOptions = optionGroups?.fixed_options;
  const variableOptions = optionGroups?.variable_options;
  const priorities = JSON.parse(JSON.stringify(optionGroups?.priorities));

  priorities.reverse().forEach(priority => {
    if (variableOptions[priority]) {
      const id = attributes[priority];
      fixedOptions = {
        ...fixedOptions,
        ...variableOptions[priority][id],
      };
    }
  });
  return fixedOptions;
};
